<template>
	<div class="feature-card-container flex-centerize flex-row">
		<AppIcon class="workflow-icon" :name="workflowTypeIconName" width="17" />
		<AppIcon class="integration-icon ml-3" v-if="integrationIconName" :name="integrationIconName" width="20" />
	</div>
</template>
<script>
import { FlowType } from '@ply-io/ply-front-shared-utilities';

import WorkflowToolService from '@/utils/workflow-tool-service';

const NOTIFICATION_ICON_NAME = 'notification';
const CLOUD_ICON = 'flow-type-cloud';
const FLOW_TYPE_TO_ICON = {
	[FlowType.Experience]: 'puzzle-tool',
	[FlowType.Cloud]: CLOUD_ICON,
	[FlowType.Sub]: 'subflow',
};

export default {
	name: 'FeatureIconsCard',
	props: {
		flowData: { type: Object },
	},
	computed: {
		workflowTypeIconName() {
			if (this.isTool) {
				if (this.isToolFromUrl) {
					return 'url';
				}
				if (this.isCommandBar) {
					return 'command-bar';
				}
				if (this.isPortal) {
					return 'portal';
				}
			}
			if (this.flowData.is_notification) {
				return NOTIFICATION_ICON_NAME;
			}
			const workflowType = this.flowData.flow_type;
			return FLOW_TYPE_TO_ICON[workflowType];
		},
		isTool() {
			return this.flowData.flow_type === FlowType.Tool;
		},
		isToolFromUrl() {
			return WorkflowToolService.isInternalToolFromUrl(this.flowData);
		},
		isPortal() {
			return WorkflowToolService.isPortalTool(this.flowData);
		},
		isCommandBar() {
			return WorkflowToolService.isCommandBarTool(this.flowData);
		},
		integrationIconName() {
			return this.flowData.context_service_slug;
		},
	},
};
</script>

<style scoped lang="scss">
.feature-card-container {
	height: 46px;
	min-width: 80px;
	border-radius: 12px;
	background: var(--bg-color);
	border: 1px solid #abb2bd6e;
	box-shadow: 0px 1px 2px #80899c4d;
}
</style>
